import { createSelector } from '@reduxjs/toolkit';
import { getLoadingCUTranslationFromDevice } from '../../CUTranslation/selectors';
import { getMyWorkspaceSelector } from '../../stoerkID/selectors/StoerkId.selectors';
import ControlUnitAPI from '../../controlUnit/api/ControlUnitAPI';
import { getDevicesDataLoadingById } from '../../commander/selectors';
import { useGroupById } from '../../groups/hooks/useGroupById';

/**
 * Get composable device loading state
 *
 * IMPROVE: This selector are not cached, to cache it, we need to not use another selectors and
 * infer all the things from each state, because we are using group as param and not the deviceId
 */
export const getComposableDeviceIsLoadingByPropGroupIdSelectorById = (
  state: any,
  props: {
    groupId?: string;
  }
): boolean => {
  const { data: group, isLoading: loadingGroup } = useGroupById(props.groupId);

  const deviceIds = group?.devices ?? [];
  const loadingDeviceId = getDevicesDataLoadingById(state);
  const isLoadingCUs = deviceIds.some((deviceId) => {
    const loadingControlUnits =
      !!ControlUnitAPI.endpoints.getControlUnitById.select(deviceId)(state)
        .isLoading;
    const loadingControlUnitsEvents =
      ControlUnitAPI.endpoints.getCurrentEventsByCommanderID.select(deviceId)(
        state
      ).isLoading;
    const loadingControlUnitsSensorData =
      ControlUnitAPI.endpoints.getCurrentSensorDataByCommanderID.select(
        deviceId
      )(state).isLoading;

    const loadingControlUnitsTranslations = !!getLoadingCUTranslationFromDevice(
      state,
      { deviceId }
    );
    return (
      loadingDeviceId ||
      loadingControlUnits ||
      loadingControlUnitsEvents ||
      loadingControlUnitsSensorData ||
      loadingControlUnitsTranslations
    );
  });
  const isLoading = loadingGroup || isLoadingCUs;
  return isLoading;
};

export const getMachinesTypeSelector = createSelector(
  [getMyWorkspaceSelector],
  (myWorkspace) => {
    return myWorkspace?.machineTypes || [];
  }
);

export const getMachineTypeSelector = createSelector(
  [
    getMachinesTypeSelector,
    (state: any, props: { machineTypeId?: string }) => props.machineTypeId,
  ],
  (machineTypes, machineTypeId: string | undefined) => {
    return machineTypes.find((machineType) => machineType.id === machineTypeId);
  }
);

export const getMachineTypeById = createSelector(
  [
    getMachinesTypeSelector,
    (state: any, machineTypeId?: string) => machineTypeId,
  ],
  (machineTypes, machineTypeId: string | undefined) => {
    return machineTypes.find((machineType) => machineType.id === machineTypeId);
  }
);
